import * as yup from 'yup';

export const employeeSchema = yup.object().shape({
  firstname: yup.string().required('This field is required'),
  lastname: yup.string().required('This field is required'),
  email: yup.string().email('email_is_not_valid_').trim(),
  phone: yup
    .string()
    .test('phone', 'phone_number_10_numbers', (value) => {
      if (!value) return true;
      const valueLength = value
        .replace(/[^\w\s]/gi, '')
        .replace(' ', '')
        .trim().length;
      return valueLength === 0 || valueLength >= 10;
    })
    .test('phone', 'phone_number_invalid', (value) => {
      if (!value) return true;
      const regExp = new RegExp('^[+ -/()0-9]*$');
      return regExp.test(value);
    })
    .trim(),
  pinCode: yup
    .string()
    .matches(/^\d{4}$/, 'Enter 4 digit code')
    .required('This field is required'),
  businesses: yup
    .array()
    .of(
      yup.object().shape({
        businessUuid: yup.string(),
        jobs: yup.array().of(
          yup.object().shape({
            _id: yup.string().nullable(),
            pay: yup.string().nullable(),
          })
        ),
      })
    )
    .min(1, 'At least one business is required'),
});
